import { number, object, string } from 'prop-types'
import { Asset } from '@opallabs/cassini'
import { extractInitials } from '@opallabs/lambda'
import { kuiperClassNames } from '../utils'

import './styles.scss'

const ChatMentionAvatar = ({ assetReference = null, name, count = null }) => (
  <div className={kuiperClassNames('chat-mention-avatar')}>
    {assetReference ? (
      <Asset
        assetReference={assetReference}
        transforms={{
          height: 24,
          width: 24,
        }}
      />
    ) : (
      <div className={kuiperClassNames('user-initials')}>
        {extractInitials(name, { maximumInitials: 2 })}
      </div>
    )}
    <p>{name}</p>
    {count ? <p className={kuiperClassNames('member_count')}>{count}</p> : null}
  </div>
)

ChatMentionAvatar.propTypes = {
  assetReference: object,
  count: number,
  name: string.isRequired,
}

export default ChatMentionAvatar
